import "./App.css";
// in App.js or index.js
import './assets/css/style.css';


import RouterComponent from "./router/router";
import Wrapper from "./wrapper Component/Wrapper";

function App() {

  return ( 
   <>
   <Wrapper>
    <RouterComponent/>
   </Wrapper>

    </>
  );
}

export default App;
